import { LoginView } from "dsl/ecosystems/CareproviderOnboardingLoginPage/useHandleLogin";
import { emailRegex } from "react-forms-state/src";
import Translations from "translations/types";
import { z } from "zod";

export type GetLoginSchemaArgs = {
  isSingleSignOn?: boolean;
  translations: Translations;
  view: LoginView;
};

type LoginSchema = ReturnType<typeof getLoginSchema>;

/** Raw form state (inputs) — `challenge` stays a string in the DOM. */
export type LoginFormValues = z.input<LoginSchema>;

/** Post-validation shape — login view normalizes empty `challenge` to `undefined`. */
export type LoginParsedValues = z.output<LoginSchema>;

/** Submit payload passed to `handleLogin`. */
export type LoginSubmitPayload = LoginParsedValues;

const ssoTokenField = z.string().optional();

/** Login view: hidden challenge input submits as omitted when empty (legacy getLoginArguments). */
const loginViewChallengeField = z
  .string()
  .transform((value) => value || undefined);

export function getLoginSchema({
  isSingleSignOn = false,
  translations,
  view,
}: GetLoginSchemaArgs) {
  if (view === "challenge") {
    return z.object({
      challenge: z
        .string()
        .min(1, translations.login.loginPage.challengeCodeValidation),
      email: z.string(),
      password: z.string(),
      ssoToken: ssoTokenField,
    });
  }

  return z.object({
    challenge: loginViewChallengeField,
    email: z
      .string()
      .regex(emailRegex, translations.login.loginPage.emailValidation),
    password: isSingleSignOn
      ? z.string()
      : z.string().min(1, translations.login.loginPage.passwordValidation),
    ssoToken: ssoTokenField,
  });
}
